import React, { useEffect, useState, useRef } from 'react';
 import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import PaginationTable from '../../pagination/Pagination4'; 

const FPS_Month_RO_Status_data = async (parms) => {   

  const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/Ro/ro_received_report`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(parms),
  });

  
  if (!response.ok) {
    throw new Error('Failed to fetch data');
  }
  
  return response.json();
};

const FPS_Month_RO_Status = ({ month, year, dist_code, afso_code, fps_id ,Status1}) => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabHeading, setTabHeading] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const fpscardstab = useRef(null); // Use ref to scroll to this div
  const [totals, setTotals] = useState([]); 
  

  const calculateTotals = (data) => {
    const columnCount = data[0].lst.length;
    const columnTotals = new Array(columnCount).fill(0); // Initialize an array for totals

    data.forEach(item => {
        item.lst.forEach((colItem, colIndex) => {
            columnTotals[colIndex] += parseFloat(colItem.allot_qty) || 0; // Sum each column's allot_qty
        });
    });
    setTotals(columnTotals); 
};

  useEffect(() => {

   // console.log("Received Props:", { month, year, dist_code, afso_code, fps_id, Status1 }); 

    const getData = async () => {
      try {
        const response_data = await FPS_Month_RO_Status_data({ month, year, dist_code, afso_code, fps_id ,Status1});
       // console.log(fps_id, "..fps_id last..type......", Status1);
        setTabHeading(response_data.heading);
        if (response_data.data && response_data.data.length > 0) {
          setReportData(response_data.data);
          calculateTotals(response_data.data); 

        } else {
          setReportData([]);
        }
      } catch (errorr) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [month, year, dist_code, afso_code, fps_id,Status1]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value === 'all' ? reportData.length : parseInt(value, 10));
    setPage(0); // Reset page to 0 when changing rows per page
  };


  useEffect(() => {
    if (!loading && !error && reportData.length > 0 && fpscardstab.current) {
      fpscardstab.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [loading, error, reportData]);


  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }
  if (error) {
    return <div className="mainhead" align="center">Internal Error</div>;
  }
  if (reportData.length === 0) {
    return <div className="mainhead" align="center">No data found</div>;
  }

  // Pagination logic
  const paginatedData = rowsPerPage === 'all' 
    ? reportData 
    : reportData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);



    // Function to apply color based on keyword
  const getFormattedHeading = (tabHeading) => {
    if (!tabHeading) return ""; 

    return tabHeading.split(" ").map((word, index) => {
        if (word === "Generated") {
            return <span key={index} style={{ color: "orange", fontWeight: "bold" }}>{word} </span>;
        } else if (word === "Pending") {
            return <span key={index} style={{ color: "orange", fontWeight: "bold" }}>{word} </span>;
        }
        else if (word === "Received") {
          return <span key={index} style={{ color: "orange", fontWeight: "bold" }}>{word} </span>;
        }
        return <span key={index}>{word} </span>; 
    });
};

  return (
    <>
      <table ref={fpscardstab} align="center" width="90%" border={1}>
        <thead>
          <tr className="tableheader">
            <th colSpan={12}>{getFormattedHeading(tabHeading)}</th>
          </tr>
          <tr className="tableheader">
          <th>Sl No</th>
	<th>FPS Id</th>
	<th>Commodity</th>
	<th>Scheme</th>
	<th>Dispatched<br/>Qty</th>
	<th>Status</th>
	<th>Truck Chit<br/>No</th>
	<th>Allocation<br/>Order No</th>
	<th>Dispatched<br/>Date</th>
	<th>Received<br/>Date</th>
          
          </tr>
          
        </thead>
        <tbody>
          {reportData.map((item, index) => (
            <tr key={item.dist_code}>
              <td style={{ textAlign: 'center' }}>{rowsPerPage === 'all' ? index + 1 : index + 1 + page * rowsPerPage}</td> {/* Adjusted Sl.No */}
              <td style={{ textAlign: 'left' }}>{item.fps_id}</td>
              <td style={{ textAlign: 'left' }}>{item.comm_name}</td>
              <td style={{ textAlign: 'left' }}>{item.scheme_name_en}</td>
              <td style={{ textAlign: 'left' }}>{item.dispatched}</td>
              <td style={{ textAlign: 'left' }}>{item.status}</td>
              <td style={{ textAlign: 'left' }}>{item.truckchitno}</td>
              <td style={{ textAlign: 'left' }}>{item.allocation_orderno}</td>
              <td style={{ textAlign: 'left' }}>{item.entry_date}</td>
              <td style={{ textAlign: 'left' }}>{item.updated_time}</td> 
         
            </tr>
          ))}
        </tbody>
        
      </table>
      <br /><br />
      <div width="75%" style={{display:'flex', justifyContent:'right',alignItems:'start' , width:'95%'}}> 
      <PaginationTable
        count={reportData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /></div>
       <br /><br /> <br /><br />
    </>
  );
};

export default FPS_Month_RO_Status;
